import { AutocompleteArrayInput, CreateButton, Datagrid, DateField, Filter, FunctionField, List, ReferenceArrayInput, ReferenceInput, SelectArrayInput, SelectInput, TextField, TopToolbar, useListContext, useTranslate } from 'react-admin';
import Permission from '../../components/Permission';
import { PERMISSIONS, frequencyChoices } from '../../constants';
import { getChainId } from '../../lib';
import CloneScoringButton from './CloneScoringButton';
import { ReferenceArrayFieldWithLimit } from '../../components';
import { filterToQuery } from '../../utils';
import ManualLinkButton from '../../manual/components/ManualLinkButton';
import FeatureIntro from '../../components/FeatureIntro';

const ScoringList = (props: any) => {
  const translate = useTranslate();
  const chainId = getChainId();

  const ListFilters = () => {
    const { filterValues } = useListContext();
    return (
      <Filter>
        <SelectInput
          label="Status"
          source="isEnabled"
          choices={[{ label: 'Ativos', value: true }, { label: 'Inativos', value: false }]}
          optionText="label"
          optionValue="value"
          emptyText="Todos"
        />
        {
          Permission({
            permission: PERMISSIONS.ADMIN, children:
              <ReferenceInput
                reference="chains"
                source="chainId"
                style={{ minWidth: 220 }}
                defaultValue={getChainId()}
                sort={{ field: 'name', order: 'ASC' }}
                perPage={9999}
              >
                <SelectInput label="Rede" optionText="name" />
              </ReferenceInput>
          })
        }
        <ReferenceArrayInput
          reference="stations"
          source="placeIds"
          sort={{ field: 'name', order: 'ASC' }}
          perPage={9999}
          filter={filterValues.chainId ? { chainId: filterValues.chainId } : {}}
          alwaysOn
        >
          <AutocompleteArrayInput
            filterToQuery={filterToQuery}
            label="Postos"
            optionText="name"
            sx={{ minWidth: 220, '& .MuiAutocomplete-inputRoot .MuiAutocomplete-input': { minWidth: 50 } }}
            noOptionsText={translate('ra.input.autocomplete.no_options_text')}
          />
        </ReferenceArrayInput>
        <ReferenceArrayInput
          reference="fuels"
          source="fuelIds"
          style={{ minWidth: 220 }}
          sort={{ field: "name", order: "ASC" }}
          alwaysOn
        >
          <SelectArrayInput label="Combustíveis" optionText="name" />
        </ReferenceArrayInput>
        <SelectInput
          label="Tipo de pontuação"
          source="type"
          choices={[{ id: "default", name: "Padrão" }, { id: "special", name: "Especial" }]}
          style={{ minWidth: 220 }}
          emptyText="Todos"
          alwaysOn
        />
      </Filter>
    );
  };

  const filterDefaultValues: any = { isEnabled: true };
  if (chainId) {
    filterDefaultValues.chainId = chainId;
  }

  return (
    <Permission permission={PERMISSIONS.SCORINGS}>
      <List
        {...props}
        title="Pontuações"
        sort={{ field: 'createdAt', order: 'DESC' }}
        filterDefaultValues={filterDefaultValues}
        filters={<ListFilters />}
        exporter={false}
        actions={
          <TopToolbar>
            {Permission({ permission: PERMISSIONS.ADMIN, children: <FeatureIntro id="manual-pontuacoes" title="Manual de Pontuações" description="Acesse o manual completo sobre pontuações para entender fatores, prioridades, bônus e muito mais."><ManualLinkButton slug="pontuacoes-especiais" label="Manual de Pontuações" /></FeatureIntro> })}
            <CreateButton />
          </TopToolbar>
        }
      >
        <Datagrid bulkActionButtons={false} rowClick="show">
          <TextField source="identify" label="Código" />
          <FunctionField label="Tipo" render={(record: any) => record && record.isDefault ? 'Padrão' : 'Especial'} textAlign="center" />
          <DateField source="startAt" label="Data de início" showTime textAlign="center" emptyText="--" locales="pt-BR" />
          <DateField source="endAt" label="Data de fim" showTime textAlign="center" emptyText="--" locales="pt-BR" />
          <FunctionField
            render={(record: any) => record && record.frequency ? frequencyChoices.find(dt => dt.id === record.frequency)?.name : '--'}
            label="Frequência"
            textAlign="center"
          />
          <FunctionField
            render={(record: any) => record && record.isEnabled ? "Ativo" : "Inativo"}
            label="Status"
            textAlign="center"
          />
          <DateField source="disabledAt" label="Desativado em" showTime textAlign="center" emptyText="--" locales="pt-BR" />
          <TextField source="description" label="Descrição" emptyText="--" textAlign="center" />
          <ReferenceArrayFieldWithLimit
            source="customerTagIds"
            reference="chains/chainId/tag"
            name="tag"
            label="Tags"
          />
          <ReferenceArrayFieldWithLimit
            source="placeIds"
            reference="stations"
            label="Postos"
            name="posto"
            link="show"
            permission={PERMISSIONS.LIST_STATION}
          />
          <CloneScoringButton />
        </Datagrid>
      </List>
    </Permission>
  );
};

export default ScoringList;
